// action types
export const GET_MLM_INPUTS_REQUEST = 'GET_MLM_INPUTS_REQUEST';
export const GET_MLM_INPUTS_SUCCESS = 'GET_MLM_INPUTS_SUCCESS';
export const GET_MLM_INPUTS_FAILURE = 'GET_MLM_INPUTS_FAILURE';

// outcomes
export const GET_MLM_OUTCOMES_REQUEST = 'GET_MLM_OUTCOMES_REQUEST';
export const GET_MLM_OUTCOMES_SUCCESS = 'GET_MLM_OUTCOMES_SUCCESS';
export const GET_MLM_OUTCOMES_FAILURE = 'GET_MLM_OUTCOMES_FAILURE';
